<div>
  <era-panel>
    <era-panel-header>
      <era-title [isDetail]="true">
        <span title
              i18n> Unenrolled devices </span>
      </era-title>
      <ml-dep-devices-delete (deleted)="dispatchDelete()"> </ml-dep-devices-delete>
      Delete selected devices
    </era-panel-header>
  </era-panel>
</div>
<ml-list-simple style="width: 100%; height: 100%"
                class="ag-theme-alpine"
                [columnDefinitions]="columnDefs"
                [dataRows]="rowData$ | async"
                [enableFilter]="true"
                [rowNodeIdProperty]="rowNodeIdProperty"
                (gridReady)="onGridReady($event)">
</ml-list-simple>